import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import Login from "./pages/login";
import Dashboard from "./pages/dashboard";
import PortFolio from "./pages/portfolio";
import ProtectedRoute from "./privateroutes/ProtectedRoute";
import Documents from "./pages/documents";
import Profile from "./pages/profile";
import Messages from "./pages/messages";
import PropertyDetail from "./pages/propertydetail";
import ResetPwd from "./pages/resetpassword";
import Transaction from "./pages/transaction";
import Projects from "./pages/projects";
import Support from "./pages/suppoert";
import ReferandEarn from "./pages/referandearn";
import './App.css';

function App() {
  return (
    <BrowserRouter basename="/investors">
      <Routes>
        <Route path="*" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login/forgot-password" element={<ResetPwd />} />
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/portfolio" element={<PortFolio />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/property-details" element={<PropertyDetail />} />
          <Route path="/transactions" element={<Transaction />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/support" element={<Support />} />
          <Route path="/referandearn" element={<ReferandEarn />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;